import React from "react";
import SystemGraphs from "./SystemGraphs";

const Kersey2Rch = () => {
  const defaultParameter = 67;

  const pageTitle = "Kersey 2 Rch";

  const endpoints = [
    { label: "15 Minutes", value: "display007-data15-min-ax1" },
    { label: "Daily", value: "display007-data-daily-ax1" },
  ];

  const parametersEndpoint = "display007-lookup-parameter";

  const mapEndpoint = "display007-map-points";

  return (
    <>
      <SystemGraphs
        defaultParameter={defaultParameter}
        pageTitle={pageTitle}
        endpoints={endpoints}
        parametersEndpoint={parametersEndpoint}
        mapEndpoint={mapEndpoint}
        //if rightAxis is true, then the graph will add a right axis based on the
        //current endpoints, only it will sub a 2 on the end instead of the 1
        rightAxis={true}
        displayIndex="007"
      />
    </>
  );
};

export default Kersey2Rch;
